module.exports = __webpack_public_path__ + "img/ImageBackground3.2707e605.png";